export class viewBtachBO {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "clearingHouseName";
  orderType: string;
  type: string = "string";
  field: string = "clearingHouseName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
}
